import { useMemo } from 'react';
import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useAccountId, useUserToken } from '../../../redux/slices/appInfo/hooks';

/**
 * The onboarding answer for the active artist. Each artist has its own "Your first release"
 * checklist (owner rule 2026-10-09), so the request names the active artist. The server answers the
 * first own artist when the active artist is not an artist of the workspace (the demo artist, or no
 * artist selected yet); `state.checklistArtist` names the artist of the answer.
 */
export function useChecklistState() {
  const trpcAPI = useTRPCAPI();
  const token = useUserToken();
  const activeAccountId = useAccountId();
  const input = useMemo(
    () => (activeAccountId === null || activeAccountId === undefined ? {} : { accountId: activeAccountId }),
    [activeAccountId]
  );
  const query = useTRPCQuery(
    trpcAPI.onboarding.state.queryOptions(input, {
      enabled: token !== null && token !== '',
      staleTime: 30_000,
    })
  );
  const { data, isLoading, error, refetch } = query;
  return useMemo(
    () => ({ state: data, isLoading, error, refetch, accountId: data?.checklistArtist?.accountId ?? null }),
    [data, isLoading, error, refetch]
  );
}
